import { Endpoints } from "@/app/infrastructures/misc/Endpoints";
// import { VoucherEndpoint } from "@/app/infrastructures/endpoints/VoucherEndpoint";
import { ProductEndpoint } from "@/app/infrastructures/endpoints/horde/ProductEndpoint";
import {
  ProductConfigurationRuleRequestParamsV4,
  RequestListCommodityV4
} from "@/data/payload/api/BookingV4Request";

// BookingV4Endpoint — facade 9 URL, delegasi ke endpoint existing (mirror V3 Endpoints/VoucherEndpoint/ProductEndpoint)
export class BookingV4Endpoint {
  private endpoints = new Endpoints();
  // private voucherEndpoints = new VoucherEndpoint();
  private productEndpoints = new ProductEndpoint();

  // GENESIS-19590 — Submit STT
  addManualBooking(): string {
    return this.endpoints.addManualBooking();
  }

  addBookingCorporate(): string {
    return this.endpoints.addBookingCorporate();
  }

  // GENESIS-19591 — Tariff estimation
  getEstimationPrice(version: string): string {
    return this.endpoints.getEstimationPrice(version);
  }

  /* GENESIS-19592 — Voucher / OTP
  getBookingVoucherList(): string {
    return this.endpoints.getBookingVoucherList();
  }

  validateBookingVoucherCode(): string {
    return this.endpoints.validateBookingVoucherCode();
  }

  issueVoucherBookingOtp(): string {
    return this.voucherEndpoints.issueVoucherBookingOtp();
  }

  cancelVoucherBookingReserve(): string {
    return this.voucherEndpoints.cancelVoucherBookingReserve();
  }
  */

  // GENESIS-19593 — Product / rule / commodity
  postToGetPosterProduct(): string {
    return this.endpoints.postToGetPosterProduct();
  }

  fetchProductConfigurationRule(
    params: ProductConfigurationRuleRequestParamsV4
  ): string {
    return this.productEndpoints.productConfigurationRuleEndpoint(params);
  }

  getCommodityList(params: RequestListCommodityV4): string {
    return this.endpoints.getCommodityList(params);
  }

  // GENESIS-19589 — Exchange rate (Est. CIPL)
  getActiveExchangeRate(from: string, to: string): string {
    return this.endpoints.getActiveExchangeRate(from, to);
  }

  // GENESIS-20970 — Saved package customer (sender-side)
  getSavedPackage(customerId: number): string {
    return this.endpoints.getCustomerSavedPackage(customerId);
  }

  getSavedPackageDetail(customerId: number, packageId: number): string {
    return this.endpoints.getCustomerSavedPackageDetail(customerId, packageId);
  }
}
